<h2 mat-dialog-title>Edit catalogue template</h2>
<mat-dialog-content>
  <form [formGroup]="form" class="edit-form">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" maxlength="25" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Game</mat-label>
      <mat-select formControlName="game_id">
        <mat-option *ngFor="let game of games" [value]="game.id">{{ game.name }}</mat-option>
      </mat-select>
      <mat-hint *ngIf="!games.length">No games available. Approve a template with a game first.</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" rows="4" maxlength="1024"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Reviewer notes</mat-label>
      <textarea matInput formControlName="notes" rows="2" maxlength="1024"></textarea>
      <mat-hint>Not shown on the public catalogue — only visible to you as reviewer</mat-hint>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="saving">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="saving || form.invalid || !games.length"
    (click)="save()"
  >
    Save
  </button>
</mat-dialog-actions>
